// src/components/SEO.jsx
// ─── SEO completo para Pura Ruta Landing ─────────────────────────────────────
// Maneja: title, meta description, Open Graph, Twitter Cards,
//         canonical URL, robots, y JSON-LD structured data.
// ─────────────────────────────────────────────────────────────────────────────

import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL    = 'https://www.pura-ruta.cr';         // 👈 cambiá a tu dominio real
const SITE_NAME   = 'Pura Ruta';
const TITLE       = 'Pura Ruta — Tu bus en tiempo real · Muy Pronto Costa Rica';
const DESCRIPTION =
  'Seguí tu autobús en tiempo real, conocé las tarifas y recibí notificaciones 5 minutos antes de que llegue. La app de buses que Costa Rica necesitaba. Muy pronto.';
const OG_IMAGE    = `${SITE_URL}/og-image.png`;   // Agregá una imagen 1200×630 en /public/

// JSON-LD — MobileApplication (ayuda a Google a entender que es una app)
const structuredData = {
  '@context':        'https://schema.org',
  '@type':           'MobileApplication',
  name:              'Pura Ruta',
  operatingSystem:   'Android, iOS',
  applicationCategory: 'TravelApplication',
  offers: {
    '@type': 'Offer',
    price:   '0',
    priceCurrency: 'CRC',
  },
  description: DESCRIPTION,
  url:         SITE_URL,
  inLanguage:  'es-CR',
  author: {
    '@type': 'Organization',
    name:    'Pura Ruta CR',
    url:     SITE_URL,
  },
};

// JSON-LD — WebPage
const webPageData = {
  '@context':   'https://schema.org',
  '@type':      'WebPage',
  name:          TITLE,
  description:   DESCRIPTION,
  url:           SITE_URL,
  inLanguage:   'es-CR',
  isPartOf: {
    '@type': 'WebSite',
    name:    SITE_NAME,
    url:     SITE_URL,
  },
};

export function SEO() {
  return (
    <Helmet>
      {/* ── Básicos ── */}
      <html lang="es-CR" />
      <title>{TITLE}</title>
      <meta name="description"        content={DESCRIPTION} />
      <meta name="robots"             content="index, follow" />
      <meta name="author"             content="Pura Ruta CR" />
      <meta name="theme-color"        content="#1D9E75" />
      <link rel="canonical"           href={SITE_URL} />

      {/* ── Geo (ayuda a buscadores regionales) ── */}
      <meta name="geo.region"         content="CR" />
      <meta name="geo.placename"      content="Costa Rica" />
      <meta name="geo.position"       content="9.7489;-83.7534" />
      <meta name="ICBM"               content="9.7489, -83.7534" />

      {/* ── Keywords relevantes (apoyo secundario) ── */}
      <meta
        name="keywords"
        content="buses Costa Rica, app autobuses CR, rastreo bus tiempo real, TUASA, horarios autobús, tarifas bus Costa Rica, transporte público CR, Pura Ruta"
      />

      {/* ── Open Graph (Facebook, WhatsApp, LinkedIn) ── */}
      <meta property="og:type"        content="website" />
      <meta property="og:url"         content={SITE_URL} />
      <meta property="og:site_name"   content={SITE_NAME} />
      <meta property="og:title"       content={TITLE} />
      <meta property="og:description" content={DESCRIPTION} />
      <meta property="og:image"       content={OG_IMAGE} />
      <meta property="og:image:width"  content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt"   content="Pura Ruta — App de autobuses en tiempo real, Costa Rica" />
      <meta property="og:locale"      content="es_CR" />

      {/* ── Twitter Card ── */}
      <meta name="twitter:card"        content="summary_large_image" />
      <meta name="twitter:title"       content={TITLE} />
      <meta name="twitter:description" content={DESCRIPTION} />
      <meta name="twitter:image"       content={OG_IMAGE} />

      {/* ── Structured Data ── */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(webPageData)}
      </script>
    </Helmet>
  );
}
